import React, { useEffect, useRef } from 'react';

let scriptPromise;
function loadTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!scriptPromise) scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.onload = () => window.turnstile ? resolve(window.turnstile) : reject(new Error('Verification unavailable'));
    script.onerror = () => { script.remove(); reject(new Error('Verification unavailable')); };
    document.head.appendChild(script);
  }).catch(error => { scriptPromise = undefined; throw error; });
  return scriptPromise;
}

export default function SignupChallenge({ siteKey, onToken, onError }) {
  const container = useRef(null);
  useEffect(() => {
    let disposed = false; let widget;
    loadTurnstile().then(turnstile => {
      if (disposed) return;
      widget = turnstile.render(container.current, {
        sitekey: siteKey, action: 'newsletter', theme: 'dark', size: 'flexible',
        callback: onToken,
        'expired-callback': () => onToken(''),
        'error-callback': () => { onToken(''); onError('Verification couldn’t load. Please reload and try again.'); },
      });
    }).catch(() => { if (!disposed) onError('Verification couldn’t load. Please reload and try again.'); });
    return () => { disposed = true; if (widget !== undefined && window.turnstile) window.turnstile.remove(widget); };
  }, [siteKey, onToken, onError]);
  return <div className="signup-challenge" ref={container} aria-label="Spam protection" />;
}
